export default "__VITE_ASSET__PmIPcFwz__"